import { isNewAuthorSearchFilterEnabled } from '@Containers/ResultsFilters/utils';
import { getRawFilterGroupsAsync, normalizeGroupsResponse } from '@Containers/ResultsFilters/ResultsFiltersService';
import { sizeChunckOfGroups, sizeChunckOfGroupsNewAuthorSearchFilter } from './BarChartCheckboxesDialogConstants';

// eslint-disable-next-line import/prefer-default-export
export async function getNomalizedGroupsAsChunksAsync(params) {
  const result = await getRawFilterGroupsAsync(params);
  const normalizedGroups = normalizeGroupsResponse(result, params);
  const { groupCount, groups } = normalizedGroups;
  const chunkSize = isNewAuthorSearchFilterEnabled(result.property) ? sizeChunckOfGroupsNewAuthorSearchFilter : sizeChunckOfGroups;
  const chunksCount = Math.ceil(groupCount / chunkSize);

  return {
    groupCount,
    chunksCount,
    chunks: groups,
  };
}
